export default __webpack_public_path__ + "static/media/lanyards_01.3a4e8507.webp";